import { render, staticRenderFns } from "./BookingInputDateView.vue?vue&type=template&id=31a5484a&scoped=true&"
import script from "./BookingInputDateView.vue?vue&type=script&lang=js&"
export * from "./BookingInputDateView.vue?vue&type=script&lang=js&"
import style0 from "./BookingInputDateView.vue?vue&type=style&index=0&id=31a5484a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5484a",
  null
  
)

export default component.exports